import { ipRegex } from '../../utils';
import * as yup from 'yup';
import { AnyObject, Maybe } from 'yup/lib/types';
import {
  REQUIRED_VALIDATION,
  IP,
  IP_VALIDATION,
  DESCRIPTION,
  IMAGE_ID,
} from '../constants';

// Declaración de tipo extendida
declare module 'yup' {
  interface StringSchema<
    TType extends Maybe<string> = string | undefined,
    TContext extends AnyObject = AnyObject,
    TOut extends TType = TType
  > {
    isIp(): StringSchema<TType, TContext>;
  }
}


yup.addMethod(yup.string, 'isIp', function () {
  return this.test('is-ip', IP_VALIDATION, function (value) {
    return value === undefined || value.trim() === ''
      ? true
      : ipRegex().test(value);
  });
});

export const modalIPSchema = yup.object().shape({
  [IP]: yup.string().isIp().required(REQUIRED_VALIDATION),
  [DESCRIPTION]: yup.string(),
});

export const modalFaceSchema = yup.object().shape({
  [DESCRIPTION]: yup.string().required(REQUIRED_VALIDATION),
  [IMAGE_ID]: yup.string().required(REQUIRED_VALIDATION),
});

export const sendRuleSchema = yup.object().shape({
  type: yup.string().required(REQUIRED_VALIDATION),
  [DESCRIPTION]: yup.string(),
});